import React, { Component } from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { Input, Header, Icon, Label } from 'semantic-ui-react'
import { setVisitDateClaimOption } from '../../../../actions'

import 'react-datepicker/dist/react-datepicker.css';

class FormsInputsDate extends Component {
    state = {
        startDate: (this.props.field) ? this.props.field.value : moment()
    }

    handleChange(date) {
        if(moment(date).diff(moment(), 'days') <= 0) {
            if(this.props.field.name == 'visitDate'){
                setVisitDateClaimOption(date)
            }
            this.setState({
                startDate: date
            });
            this.props.form.setFieldValue(this.props.field.name, date)
        }
        if(this.props.field.name == 'dateFrom'){
            this.setState({
                startDate: date
            });
            this.props.form.setFieldValue(this.props.field.name, date)
        }
    }

    render() {
        const { label, minDate, maxDate, disabled } = this.props;
        return (
            <div className="field">
                <>
                    <Header as='h5'>{label}</Header>
                </>
                <DatePicker
                    dateFormat="DD MMM YYYY"
                    customInput={<Input labelPosition="right" label={<Label><Icon name="calendar alternate outline"/></Label>} />}
                    selected={this.state.startDate}
                    onChange={this.handleChange.bind(this)}
                    minDate={(minDate) ? minDate : null}
                    maxDate={(maxDate) ? maxDate : null}
                    disabled={(disabled) ? disabled : false}
                />
            </div>
        );
    }
}

export default FormsInputsDate;
